export default "__VITE_ASSET__171b4edb__"